import { getModifiedDate, parseLocalDate } from "../helperFuncs"


export const getAccruals = (loads, assetLoads, startDate, endDate) => {
  let totals = {
    total_loads: 0,
    freight_weight_tons: 0,
    freight_weight_not_billed: 0,
    freight_weight_not_received: 0,
    sand_weight_tons: 0,
    sand_weight_not_billed: 0,
    sand_weight_not_received: 0,
    freight_rev: 0,
    freight_not_billed: 0,
    freight_cost: 0,
    freight_not_received: 0,
    sand_rev: 0,
    sand_not_billed: 0,
    sand_cost: 0,
    sand_not_received: 0,
  }
  let totalAssets = {
    total_loads: 0,
    freight_weight_tons: 0,
    freight_weight_not_billed: 0,
    freight_weight_not_received: 0,
    freight_rev: 0,
    freight_not_billed: 0,
    freight_cost: 0,
    freight_not_received: 0,
  }
  let accruedLoads = []
  let accruedAssetLoads = []
  let start = new parseLocalDate(startDate)
  start.setHours(0,0,0,0)
  let end = new parseLocalDate(endDate)
  end.setHours(23,59,59,59)
  loads.forEach(load => {
    let load_date = getModifiedDate(load.delivered_date)
    if (load_date >= start && load_date < end && !load.is_canceled) {
      let loadData = {}
      loadData['load_no'] = load.load_no
      loadData['delivered_date'] = load.delivered_date
      loadData['carrier_name'] = load.carrier_name
      loadData['terminal_name'] = load.terminal_name
      loadData['product_name'] = load.product_name
      loadData['po_number'] = load.po_number
      loadData['ticket_number'] = load.ticket_number
      loadData['approved_mileage'] = load.approved_mileage
      loadData['weight_tons'] = load.weight_tons
      loadData['freight_rev'] = load.freight_rev
      loadData['freight_cost'] = load.freight_cost
      loadData['fsc_rev'] = load.fsc_rev
      loadData['fsc_cost'] = load.fsc_cost
      loadData['sand_rev'] = load.sand_rev
      loadData['sand_cost'] = load.sand_cost
      loadData['total_rev'] = load.freight_rev + load.fsc_rev + load.sand_rev
      loadData['total_cost'] = load.freight_cost + load.fsc_cost + load.sand_cost
      loadData['customer_invoice_id'] = load.customer_invoice_id
      loadData['vendor_invoice_id'] = load.vendor_invoice_id
      loadData['sand_invoice_id'] = load.sand_invoice_id

      // calc totals
      totals.total_loads = totals.total_loads + 1
      totals.freight_weight_tons = totals.freight_weight_tons + load.weight_tons
      totals.freight_rev = totals.freight_rev + load.freight_rev + load.fsc_rev
      totals.freight_cost = totals.freight_cost + load.freight_cost + load.fsc_cost
      totals.sand_rev = totals.sand_rev + load.sand_rev
      totals.sand_cost = totals.sand_cost + load.sand_cost
      if (load.sand_rev > 0) {
        totals.sand_weight_tons = totals.sand_weight_tons + load.weight_tons
      }
      
      if (load.customer_invoice_id === 0) {
        totals.freight_weight_not_billed = totals.freight_weight_not_billed + load.weight_tons
        totals.freight_not_billed = totals.freight_not_billed + load.freight_rev + load.fsc_rev
        if (load.sand_rev > 0) {
          totals.sand_weight_not_billed = totals.sand_weight_not_billed + load.weight_tons
          totals.sand_not_billed = totals.sand_not_billed + load.sand_rev
        }
      }

      if (load.vendor_invoice_id === 0) {
        totals.freight_weight_not_received = totals.freight_weight_not_received + load.weight_tons
        totals.freight_not_received = totals.freight_not_received + load.freight_cost + load.fsc_cost
      }

      if (load.sand_invoice_id === 0 && load.sand_cost > 0) {
        totals.sand_weight_not_received = totals.sand_weight_not_received + load.weight_tons
        totals.sand_not_received = totals.sand_not_received + load.sand_cost
        
      }
      accruedLoads.push(loadData) 
    }
  })
  if (assetLoads) {
    assetLoads.forEach(load => {
      let load_date = getModifiedDate(load.delivered_date)
      if (load_date >= start && load_date < end && !load.is_canceled) {
        let loadData = {}
        loadData['load_no'] = load.load_no
        loadData['delivered_date'] = load.delivered_date
        loadData['carrier_name'] = load.carrier_name
        loadData['approved_mileage'] = load.approved_mileage
        loadData['weight_tons'] = load.weight_tons
        loadData['freight_rev'] = load.freight_rev
        loadData['freight_cost'] = load.freight_cost
        loadData['fsc_rev'] = load.fsc_rev
        loadData['fsc_cost'] = load.fsc_cost
        loadData['total_rev'] = load.freight_rev + load.fsc_rev
        loadData['total_cost'] = load.freight_cost + load.fsc_cost
        loadData['customer_invoice_id'] = load.customer_invoice_id
        loadData['vendor_invoice_id'] = load.vendor_invoice_id
        // calc totals
        totalAssets.total_loads = totalAssets.total_loads + 1
        totalAssets.freight_weight_tons = totalAssets.freight_weight_tons + load.weight_tons
        totalAssets.freight_rev = totalAssets.freight_rev + load.freight_rev + load.fsc_rev
        totalAssets.freight_cost = totalAssets.freight_cost + load.freight_cost + load.fsc_cost
        
        if (load.customer_invoice_id === 0) {
          totalAssets.freight_weight_not_billed = totalAssets.freight_weight_not_billed + load.weight_tons
          totalAssets.freight_not_billed = totalAssets.freight_not_billed + load.freight_rev + load.fsc_rev
        }
  
        if (load.vendor_invoice_id === 0) {
          totalAssets.freight_weight_not_received = totalAssets.freight_weight_not_received + load.weight_tons
          totalAssets.freight_not_received = totalAssets.freight_not_received + load.freight_cost + load.fsc_cost
        }
        accruedAssetLoads.push(loadData) 
      }
    })
  }
  
  
  return [accruedLoads, accruedAssetLoads, totals, totalAssets]
}